export const APPLE_SUBSCRIPTION_PRODUCTS = Object.freeze([
  Object.freeze({productId: 'com.silahub.silatrail.subscription.mileage.monthly', planType: 'mileage', billingCycle: 'monthly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.mileage.yearly', planType: 'mileage', billingCycle: 'yearly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.solo.monthly', planType: 'solo', billingCycle: 'monthly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.solo.yearly', planType: 'solo', billingCycle: 'yearly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.entrepreneur.monthly', planType: 'entrepreneur', billingCycle: 'monthly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.entrepreneur.yearly', planType: 'entrepreneur', billingCycle: 'yearly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.portfolio.monthly', planType: 'portfolio', billingCycle: 'monthly'}),
  Object.freeze({productId: 'com.silahub.silatrail.subscription.portfolio.yearly', planType: 'portfolio', billingCycle: 'yearly'})
]);

export const APPLE_SUBSCRIPTION_PRODUCT_IDS = Object.freeze(
  APPLE_SUBSCRIPTION_PRODUCTS.map(({productId}) => productId)
);

const APPLE_PRODUCT_BY_ID = new Map(
  APPLE_SUBSCRIPTION_PRODUCTS.map((product) => [product.productId, product])
);

export function getAppleSubscriptionProduct(productId) {
  return APPLE_PRODUCT_BY_ID.get(productId) || null;
}

export function isAppleSubscriptionProduct(productId) {
  return APPLE_PRODUCT_BY_ID.has(productId);
}

export function findAppleSubscriptionProduct(planType, billingCycle) {
  return APPLE_SUBSCRIPTION_PRODUCTS.find(
    (product) => product.planType === planType && product.billingCycle === billingCycle
  ) || null;
}
